import { render, staticRenderFns } from "./dkkd-add-images.vue?vue&type=template&id=2c53f1a6&scoped=true"
import script from "./dkkd-add-images.vue?vue&type=script&lang=js"
export * from "./dkkd-add-images.vue?vue&type=script&lang=js"
import style0 from "./dkkd-add-images.vue?vue&type=style&index=0&id=2c53f1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53f1a6",
  null
  
)

export default component.exports